export function computeSpeed(distance: number, timeSeconds: number): number | undefined {
	return timeSeconds > 0 ? Math.round(distance / (timeSeconds / 3600)) : undefined;
}
